/**
 * Wallet API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RegistryTypeDto = {
    Person: 'PERSON',
    Company: 'COMPANY'
} as const;
export type RegistryTypeDto = typeof RegistryTypeDto[keyof typeof RegistryTypeDto];

